module.exports = __webpack_public_path__ + "static/media/googleicon.b62d39c4.svg";